"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegistrationNumberTextBoxQuestionWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var VehicleRegistrationNumberTextBoxQuestionWidget = /** @class */ (function (_super) {
    __extends(VehicleRegistrationNumberTextBoxQuestionWidget, _super);
    function VehicleRegistrationNumberTextBoxQuestionWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VehicleRegistrationNumberTextBoxQuestionWidget.prototype.renderInputField = function () {
        var inputFieldProps = _super.prototype.renderInputField.call(this).props;
        return (React.createElement("div", { className: "vrn-text-box" },
            React.createElement("div", { className: "vrn-text-box__country-code-wrapper" },
                React.createElement("span", { className: "vrn-text-box__country-code" }, "GB")),
            React.createElement("input", __assign({}, inputFieldProps, { className: "vrn-text-box__input-field ".concat(inputFieldProps.className) }))));
    };
    VehicleRegistrationNumberTextBoxQuestionWidget.prototype.handleOnChangeEvent = function (event) {
        event.target.value = event.target.value.replace(/\s+/g, '').toUpperCase();
        _super.prototype.handleOnChangeEvent.call(this, event);
    };
    return VehicleRegistrationNumberTextBoxQuestionWidget;
}(plugin_journey_1.TextBoxQuestionWidget));
exports.VehicleRegistrationNumberTextBoxQuestionWidget = VehicleRegistrationNumberTextBoxQuestionWidget;
//# sourceMappingURL=VehicleRegistrationNumberTextBoxQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/motorCommon/VehicleRegistrationNumberTextBoxQuestionWidget.js
// module id = 3441
// module chunks = 0